<template>
	<div>
		<div style="color: #3e3e3e;margin-bottom: 15px;">
			物资管理>{{activeName=="one"?"门店物资":""}}{{activeName=="two"?"物资列表":""}}</div>
		<el-tabs type="border-card" v-model="activeName">
			<el-tab-pane name="one" label="门店物资">
				<list1></list1>
			</el-tab-pane>
			<el-tab-pane name="two" label="物资列表">
				<list2></list2>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import list1 from "./storeMaterial.vue"
	import list2 from "./material.vue"
	export default {
		components: {
			list1,
			list2,
		},
		data() {
			return {
				activeName: "one"
			};
		},
		mounted() {
			if (this.$route.query.id == 1) {
				this.activeName = "one"
			}
			if (this.$route.query.id == 2) {
				this.activeName = "two"
			}
		},
		methods: {
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
		},
	};
</script>
<style lang="less" scoped>

</style>